import React from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

// import useStrategicAccounts from "../../../hooks/use-strategic-accounts";
import { useMutation } from "../../hooks/use-mutation";
// import RebatesClient from "../../../RebatesClient";

import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormElement, FormikTextField } from "../../components";

import css from "./modal-dealer.module.css";
import { useNavigate } from "react-router-dom";
import RebatesClient from "../../RebatesClient";

const ModalDealer = ({
  open,
  onClose,
  dealer,
}) => {
   const navigate = useNavigate();

  
  const validationSchema = Yup.object({
    name: Yup.string().required("Dealer name is required"),
    address: Yup.string()/*.required("Address is required")*/,
  });

  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveDealer",
    networkMode: "always",
    mutationFn: async (updatedData) =>  RebatesClient.saveDealer(updatedData,  dealer?.id),
    onError: (err)=> {console.log(err)},
    onSuccess: (resp) => {
      if(resp.response.status == 200){
        // navigate(`/dealer/${encodeURIComponent(formik.values.name)}`, { replace: account?.id ? true : false })
        close()
      }
      else {
        alert(`Error saving dealer, ${resp.body.status}`)
      }

    }
  });
  

  const formik = useFormik({
    initialValues: {
      name: dealer?.name || "",
      address: dealer?.address || "",
    },

    validationSchema: validationSchema,
    onSubmit: submitRequest,
  });

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon={dealer?.id ? "Edit" : "Plus"} />
      {dealer?.id ? "Edit" : "Add"} Dealer
    </div>
  );

  function close(){
    formik.resetForm()
    onClose()
  }

  return (
    <CustomDialog open={open} onClose={close} width={640} title={title}>
      <FormikProvider value={formik}>
        <Form className={css.modalForm}>
          <FormikTextField
            label="Dealer Name*"
            labelShrink={true}
            name="name"
            type="text"
            value={formik.values.name}
          />

          <FormikTextField
            label="Dealer Address*"
            labelShrink={true}
            name="address"
            type="text"
            value={formik.values.address}
          />
          
          <div className={css.actions}>
            <CustomButton
              label="Cancel"
              onClick={onClose}
              color="secondary"
            />

            <CustomButton
              label="Save"
              type="submit"
              color="primary"
              onSubmit={formik.handleSubmit}
            />
          </div>
        </Form>
      </FormikProvider>
    </CustomDialog>
  );
};

export default ModalDealer;
